// SharedTemplateHeader.js - Consistent header component for all template scenes
// Maintains desktop/mobile separation while providing consistent navigation

export function createTemplateHeader(sceneTitle, breadcrumbPath = ['Home', 'Dashboard']) {
    return `
        <header class="template-header">
            <div class="template-header-left">
                <a href="#" class="template-header-logo" data-action="dashboard">
                    <div class="template-header-logo-icon">D</div>
                    <div class="template-header-logo-text">DeckOps.ai</div>
                </a>
                <div class="template-header-info">
                    <h1 class="template-header-title">${sceneTitle}</h1>
                    <nav class="template-header-breadcrumb">
                        ${breadcrumbPath.map((item, index) => 
                            index === breadcrumbPath.length - 1 
                                ? `<span>${item}</span>`
                                : `<span>${item}</span><span class="template-header-breadcrumb-separator">/</span>`
                        ).join('')}
                    </nav>
                </div>
            </div>
            <div class="template-header-actions">
                <button class="template-back-btn" data-action="dashboard">
                    <span class="template-back-btn-icon">←</span>
                    <span>Back to Dashboard</span>
                </button>
            </div>
        </header>
    `;
}

export function loadTemplateHeaderCSS() {
    // Load shared header CSS if not already loaded
    if (!document.getElementById('shared-template-header-css')) {
        const link = document.createElement('link');
        link.id = 'shared-template-header-css';
        link.rel = 'stylesheet';
        link.href = '/shared-template-header.css?v=' + Date.now();
        document.head.appendChild(link);
        console.log('🎨 Loaded shared template header CSS');
    }
    
    // Load shared logo CSS if not already loaded
    if (!document.getElementById('shared-logo-css')) {
        const logoLink = document.createElement('link');
        logoLink.id = 'shared-logo-css';
        logoLink.rel = 'stylesheet';
        logoLink.href = '/shared-logo-component.css?v=' + Date.now();
        document.head.appendChild(logoLink);
        console.log('🎨 Loaded shared logo CSS');
    }
}

export function bindTemplateHeaderEvents(scene) {
    // Bind header navigation events
    setTimeout(() => {
        const headerActions = document.querySelectorAll('.template-header [data-action]');
        headerActions.forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                const action = e.currentTarget.dataset.action;
                console.log(`🔗 Template header action: ${action}`);
                
                if (action === 'dashboard') {
                    console.log('🔗 Template header: Navigating to dashboard (preventing duplicates)');
                    // CRITICAL: Check if we're already transitioning to prevent duplicates
                    if (window.game?.scene?.isActive('AuthenticatedMenuSceneDOM')) {
                        console.log('🔗 Already on dashboard - ignoring duplicate navigation');
                        return;
                    }
                    scene.startScene('AuthenticatedMenuSceneDOM');
                } else if (scene.handleAction) {
                    scene.handleAction(action);
                }
            });
        });
        console.log('🔗 Template header events bound');
    }, 100);
}
